import { render, staticRenderFns } from "./FabricantesView.vue?vue&type=template&id=1bf9add8&scoped=true"
import script from "./FabricantesView.vue?vue&type=script&lang=js"
export * from "./FabricantesView.vue?vue&type=script&lang=js"
import style0 from "./FabricantesView.vue?vue&type=style&index=0&id=1bf9add8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9add8",
  null
  
)

export default component.exports